import React from 'react'

interface ErrorMessageProps {
  message: string
}

const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <div className="mr-8 mt-0 text-left text-sm font-medium text-red-500">
      {message}
    </div>
  )
}

export default ErrorMessage
